/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Copilot_Sugganimating1Inputs */

const zh_landing_copilot_sugganimating1 = /** @type {(inputs: Landing_Copilot_Sugganimating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`动画教学`)
};

const en_landing_copilot_sugganimating1 = /** @type {(inputs: Landing_Copilot_Sugganimating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animating Lessons`)
};

const es_landing_copilot_sugganimating1 = /** @type {(inputs: Landing_Copilot_Sugganimating1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecciones animadas`)
};

/**
* | output |
* | --- |
* | "Animating Lessons" |
*
* @param {Landing_Copilot_Sugganimating1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_copilot_sugganimating1 = /** @type {((inputs?: Landing_Copilot_Sugganimating1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Copilot_Sugganimating1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_copilot_sugganimating1(inputs)
	if (locale === "en") return en_landing_copilot_sugganimating1(inputs)
	return es_landing_copilot_sugganimating1(inputs)
});
export { landing_copilot_sugganimating1 as "landing_copilot_suggAnimating" }